export default __webpack_public_path__ + "static/media/G0120.34I-29375_-17330_0.1666197120000.97553ff8.jpg";